<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="this.titleinvoice + ' ' + $t('invoices')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>

      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_invoice") }}
          </button>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="p-primary align-items-center primary-card-color border-bottom">
          <ul class="nav tab-filter-menu d-inline-flex justify-content-flex-end">
            <li
              class="nav-item"
              v-for="(item, index) in userFilterOptions"
              :key="index"
            >
              <a
                href="#"
                class="nav-link font-size-default py-0"
                :class="[
                  filteredData.status == item.id
                    ? 'active'
                    : index === 0 && filteredData.status === ''
                    ? 'active'
                    : '',
                ]"
                @click.prevent="getFilterValue(item.id)"
              >
                {{ item.value }}
              </a>
            </li>
          </ul>
          <div class="float-right">
            <app-search @input="getSearchValue" />
          </div>
        </div>
      </div>

    </div>
    <app-table
      :id="tableId"
      :options="options"
      :filtered-data="filteredData"
      @action="getListAction"
    />

    <customerinvoice-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :closeAddEditModal="closeAddEditModal"
      @close-modal="closeAddEditModal"
    />
    <customerinvoice-editmodal
      v-if="isEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :closeAddEditModal="closeEditModal"
      @close-modal="closeEditModal"
    />
    <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import { axiosGet, axiosDelete } from "../../../../../Helpers/AxiosHelper";

export default {
  // extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  data() {
    return {
      invoice: {},
      isAddEditModalActive: false,
      isEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      titleinvoice: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.CUSTOMER_INVOICE_LISTING,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("invoice_#"),
            type: "custom-html",
            key: "invoice_number",
            modifier: (value,row) => {
              return `<a href="#" id="${row.invoice_to}"  data-attribute="${row.invoice_to}" @click=${this.myFunction(row.invoice_to)}>${this.$t(value)}</a>`; 
            },
          },
          // {
          //   title: this.$t("customers"),
          //   type: "custom-html",
          //   key: "company_name",
          //   modifier: (value) => {
          //     let company_name = value ;
          //     this.titleinvoice = company_name;
          //     return `<span>${this.$t(value.company_name)}</span>`;
          //   },
          // },
          {
            title: this.$t("customer"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              let company_name = value ? value.company_name : '---';
              return `<span>${this.$t(company_name)}</span>`;
            },
          },
          {
            title: this.$t("invoice_date"),
            type: "custom-html",
            key: "invoice_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              var result = '';
              let ClassName = "warning";

              if (value == null) {
                result = "None";
                ClassName = 'danger';
              }
              else {
                const moment = require('moment');
                // Define your due date and current date
                const dueDate = moment(value+' 23:59:59'); // Replace with your due date
                const currentDate = moment(); // Current date and time

                // Calculate the difference in time
                const timeDiff = dueDate.diff(currentDate);
                if (timeDiff > 0) {
                  const duration = moment.duration(timeDiff);
                  if (duration.days() > 0) {
                    result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                    if(duration.days() > 30) {
                      ClassName = 'success';
                    }
                  } else if (duration.hours() > 0) {
                    result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                  } else {
                    result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                  }
                } else {
                    result = 'The due date has passed.';
                    ClassName = 'danger';
                }
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                  result
              )}</span>`;
            },
          },
          {
            title: this.$t("total"),
            type: "custom-html",
            key: "amount",
            modifier: (value) => {
              return `<span>${this.$t(value ? value.toString() : 0)}</span>`;
            },
          },
          {
            title: this.$t("paid_due"),
            type: "custom-html",
            key: "amount_due",
            modifier: (value) => {
              return `<span>${this.$t(value ? value.toString() : 0)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let val = "";

              if (value === "succeeded") {
                ClassName = `success`;
                val = "Paid";
              } else if (value === "pending") {
                ClassName = `warning`;
                val = "Overdue";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                val
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          // {
          //   title: this.$t("view"),
          //   icon: "eye",
          //   type: "none",
          //   // component: "app-add-modal",
          //   // modalId: "demo-add-edit-Modal",
          // },
          {
            title: this.$t("view_history_report"),
            type: "none",
            icon: "clipboard",
          },
          {
              title: this.$t('copy'),
              type: 'none',
              icon: "copy",
          },
          {
              title: this.$t('export_pdf'),
              type: 'none',
              icon: 'download',
          },
          {
              title: this.$t('delete'),
              icon: 'trash',
              type: 'none',
              component: 'app-confirmation-modal',
              modalId: 'demo-delete',
          },
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All Invoices" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Overdue" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;
      
      this.$hub.$emit("reload-" + this.tableId);
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    closeEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      // if (actionObj.title == this.$t("view")) {
      //   // window.location = "/buyer/customer/invoice/list/" + rowData.customer_id;
      //   window.location = '/buyer/customer/invoice/view/'+ rowData.id;
      // } 
      if (actionObj.title == this.$t("edit")) {
        if (rowData.status == "succeeded") {
          this.$toastr.s("You are already paid customer");
        } else {
          this.selectedUrl = `${actions.CUSTOMER_INVOICE_SHOW}/${rowData.id}`;
          this.isEditModalActive = true;
        }
      }
      else if (actionObj.title == this.$t("view_history_report")) {
        // window.location = "/buyer/customer/invoice/list/" + rowData.customer_id;
        // this.$emit("id", rowData.customer_id);
        this.view(rowData.invoice_to);
      }
      else if (actionObj.title == 'Copy') {
        this.copyInvoice();
      }
      else if (actionObj.title == this.$t("export_pdf")) {
        this.invoicePdf();
      }
      else if (actionObj.title == 'Delete') {
        // this.copyInvoice();
        this.openDeleteModal();
      }
    },
    view(invoice_to) {
      this.$emit("id", invoice_to);
    },
    myFunction(id){
        let doc = document.getElementById(id);
        if(doc){
            doc.addEventListener('click', () => {
              this.view(id)
            }) ;
        }
        },

    copyInvoice() {
      // alert('a');
      let url = `${actions.INVOICE_COPY}/${this.rowData.id}`;
      this.preLoader = true;
      axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          // $("#demo-delete").modal("hide");
          // this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });

    },
    invoicePdf() {
      // alert('a');
      let url = `${actions.CUSTOMER_INVOICE_PDF}/${this.rowData.id}`;

      window.location = url;
      // router.push(url);
      this.preLoader = true;
      // axiosGet(url)
      //   .then((response) => {
      //     this.deleteLoader = false;
      //     // $("#demo-delete").modal("hide");
      //     // this.cancelled();
      //     this.$toastr.s(response.data.message);
      //     // this.searchAndSelectFilterOptions();
      //   })
      //   .catch(({ error }) => {
      //     // Trigger after error
      //   })
      //   .finally(() => {
      //     this.$hub.$emit("reload-" + this.tableId);
      //   });

    },

    // getCompanyName() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   
    //   let id = split[6].split("?")[0];
    //   
    //   axiosGet(actions.COMPANY_NAME + "/" + id)
    //     .then((response) => {
    //       
    //       this.titleinvoice = response.data.company_name;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },

    // getInvoice() {
    //   let myLocation = location.href;
    //   let split = myLocation.split("/");
    //   let split_ = split[6].split("?");
    //   
    //   // let a = this.options.url.append(this.id);
    //   
    //   this.options.url = this.options.url + "/" + split_[0];
    // },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.CUSTOMER_INVOICE_DESTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
  mounted() {
    // this.getInvoiceDownload();
    // this.getInvoice();
    // this.getCompanyName();
  },
};
</script>
